import { render, staticRenderFns } from "./BusinessFrontPageImagesSummaryCard.vue?vue&type=template&id=53491906&"
import script from "./BusinessFrontPageImagesSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./BusinessFrontPageImagesSummaryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports